import type { PicklistItem } from '@efdigital/ll-addon-data';
import { DataTypeSystem } from '@efdigital/ll-addon-data/data-types';
import { page } from '@efdigital/ll-admin-v2/data/json-api';
import { jsonApiOptions } from '@efdigital/ll-admin-v2/lib/json-api';
import { query } from '@warp-drive/utilities/json-api';

export function queryPicklistItemsByGroupName(groupName: string) {
  return query<PicklistItem>(
    DataTypeSystem.PicklistItem,
    {
      'filter[group]': groupName,
      ...page({ offset: 0, limit: 100 }),
    },
    jsonApiOptions
  );
}
